
import React from 'react';
import { StatusBadge } from '../../../../shared/components/badges/StatusBadge';
import TabbedForm from '../../../../shared/components/forms/FormTabs';
import TalukaExpandedRow from '../components/TalukaExpandRow';
import { TalukaService } from '../../../../shared/services/TalukaService';
import apiService from '../../../../shared/services/apiService';

// District Options from dropdowns API
export const getDistrictOptions = async () => {
  try {
    const res = await apiService.getAll('dropdowns/districts?isDropdown=true');
    const districts =
      res?.data?.districts ||
      res?.districts ||
      res?.data ||
      [];

    return districts.map(d => ({
      value: d.value || d.id || d._id,
      label: d.label || d.name
    }));
  } catch (error) {
    console.warn('Failed to load districts from dropdowns API', error);
    return [];
  }
};

// District filter options for filtering talukas by district
export const getDistrictFilterOptions = async () => {
  try {
    const res = await apiService.getAll('dropdowns/districts?isDropdown=true');
    const districts =
      res?.data?.districts ||
      res?.districts ||
      res?.data ||
      [];

    return districts.map(d => ({
      value: d.value || d.id || d._id,
      label: d.label || d.name
    }));
  } catch (error) {
    console.warn('Failed to load districts for filter', error);
    return [];
  }
};


export const getRoleOptions = async () => {
  try {
    const res = await TalukaService.getRoles?.();
    if (res?.data) {
      return res.data.map(r => ({
        value: r.value || r.id,
        label: r.label || r.name
      }));
    }
  } catch (error) {
    console.warn('Failed to load roles', error);
  }
  // Fallback options
  return [
    { value: "officer", label: "Taluka Officer" },
    { value: "coordinator", label: "Coordinator" },
    { value: "admin", label: "Administrator" }
  ];
};

// ------------------------------
// Taluka Config
// ------------------------------
export const talukaConfig = {
  title: 'Taluka',
  endpoint: 'admin/talukas',
  crudEndpoint: 'talukas',
  storageKey: 'talukas',
  dataUrl: '/data/talukas.json',
  useUrlNavigation: true,
  basePath: '/admin/taluka',

  // Custom filter for District
  customFilters: [
    {
      key: 'districtId',
      label: 'District',
      placeholder: 'All Districts',
      optionsLoader: getDistrictFilterOptions
    }
  ],

  columns: [
    { key: 'name', label: 'Taluka Name', render: (item) => item.name },
    { key: 'district', label: 'District', render: (item) => item.district?.name },
    { key: 'status', label: 'Status', render: (item) => <StatusBadge status={item.status} /> }
  ],

  formFields: [
    {
      name: 'name',
      label: 'Taluka Name',
      type: 'text',
      required: true,
      placeholder: 'Enter Taluka name',
      section: 'basic'
    },
    {
      name: 'districtId',
      label: 'District',
      type: 'select',
      optionsLoader: getDistrictOptions,
      required: true,
      placeholder: 'Select District',
      section: 'basic',
      renderValue: (value, item) => item?.district?.name || value || '—'
    },
    {
      name: 'talukaCode',
      label: 'Taluka Code',
      type: 'text',
      required: true,
      placeholder: 'e.g., TEST-01',
      section: 'basic'
    },
    // {
    //   name: 'status',
    //   label: 'Status',
    //   type: 'select',
    //   optionsLoader: getStatusOptions,
    //   required: true,
    //   default: 'ACTIVE',
    //   section: 'basic'
    // },

    // Contact Section
    {
      name: 'contactPerson',
      label: 'Contact Person',
      type: 'text',
      required: true,
      placeholder: 'Officer or Representative',
      section: 'contact'
    },
    {
      name: 'phone',
      label: 'Phone Number',
      type: 'tel',
      required: true,
      placeholder: '9876543220',
      section: 'contact'
    },
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      required: true,
      placeholder: 'taluka@example.com',
      section: 'contact'
    },
    {
      name: 'officeAddress',
      label: 'Office Address',
      type: 'textarea',
      rows: 3,
      required: true,
      placeholder: 'Taluka Office, Block Road',
      fullWidth: true,
      section: 'contact'
    }
  ],

  searchFields: ['name', 'district'],

  customHandlers: {
    onView: async (item) => {
      try {
        // Fetch fresh data from API
        const response = await TalukaService.getById(item.id || item._id);
        const data = response?.data?.data || response?.data || response;

        // Map district ID from nested object for form fields
        if (data.district) {
          data.districtId = data.district.id || data.district._id;
        }
        return data;
      } catch (error) {
        console.error('Failed to fetch taluka details:', error);
        // Fallback to item data if API fails
        const data = { ...item };
        if (data.district) {
          data.districtId = data.district.id || data.district._id;
        }
        return data;
      }
    },

  formState: { activeTab: "basic" },
    
    renderFormSections: (formFields, formData, handleFormChange, mode, renderFormField, activeTab, setActiveTab) => {
      const tabsConfig = {
        basic: { label: "Basic Info" },
        contact: { label: "Contact Info" },
      };
      return <TabbedForm formFields={formFields} formData={formData} handleFormChange={handleFormChange} renderFormField={renderFormField} tabsConfig={tabsConfig} activeTab={activeTab} setActiveTab={setActiveTab} />;
    },

    renderExpandedRow: (item) => <TalukaExpandedRow item={item} />,

    processFormData(formData, mode) {
      return {
        name: formData.name,
        districtId: formData.districtId,
        talukaCode: formData.talukaCode,
        contactPerson: formData.contactPerson,
        phone: formData.phone,
        email: formData.email,
        officeAddress: formData.officeAddress,
        status: formData.status || "ACTIVE"
      };
    }
  }
};
